import React from 'react'
import { usePage } from 'hooks'
import Header from 'components/app/Header'
import PageBody from 'components/app/PageBody'
import CompanyBreadcrumb from 'components/company/CompanyBreadcrumb'
import CompanyContainer from 'components/company/view/CompanyContainer'
import BannerContainer from 'components/company/view/BannerContainer'

export default function CompanyPage() {
  const { header } = usePage()

  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <CompanyBreadcrumb crumbs={header?.crumbs} />
          </Header>
          <BannerContainer />
        </>
      )}
      renderContent={() => <CompanyContainer />}
    />
  )
}
